import { AppBar, CssBaseline, Drawer, IconButton, List, Toolbar } from '@material-ui/core'
import { createTheme, makeStyles, ThemeProvider, useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import clsx from 'clsx'
import jwt from 'jwt-decode'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { matchPath, Redirect, Route, Switch, useHistory, useLocation, useParams } from 'react-router-dom'

import { getFacilities, setFacility } from '../actions/facilities/facilities.actions'
import { getConstants } from '../actions/general.actions'
import { getBalances, getHouseholdById, getTransactions } from '../actions/households/households.actions'
import { getMarkets } from '../actions/markets/markets.actions'
import { getStaffById } from '../actions/Team/team.actions'
import { getUser, setUser } from '../actions/users.actions'
import FacilityList from '../components/Facilities/FacilityList'
import { withFirebaseHOC } from '../components/Firebase'
import UserMenu from '../components/Menus/User/UserMenu'
import Alert from '../components/Misc/Alert'
import {
	AddPetsNavLinks,
	AdminCrumbs,
	AdminNavLinks,
	AppointmentMatchNavLinks,
	AppointmentsNavLinks,
	ClientNavLinks,
	ContactsNavLinks,
	CreateClientNavLinks,
	FacilityBasicInfoNavLinks,
	FacilityBookingNav,
	FacilitySetupNavItems,
	FacilityMarketingNavItems,
	HouseholdDataNavLinks,
	HouseholdNavLinks,
	MembershipNavLinks,
	MonitorNavLinks,
	NavItems,
	GroomingNav,
	PathMonitorNavLinks,
	PetMatchNavLinks,
	PlaygroupNavLinks,
	PlaygroupsNavLinks,
	SettingsBreadCrumbs,
	GroomingBreadCrumbs,
	FacilityMarketingBreadCrumbs,
	SettingsNavLinks,
	StaffNavLinks,
	UnassignedNavLinks,
	FacilityTrainingSetupNav,
	TrainingNav,
	TrainingBreadCrumbs
} from '../components/NavLinks'
import No from '../components/Misc/NoAccess'
import PaymentNavLinks from '../components/NavLinks/PaymentNavLinks'
import PetsNavLinks from '../components/NavLinks/PetsNavLinks'
import { Loading, Login } from '../pages'
import { privateRoutes } from '../routes/routes'
import { api } from '../services/api'
import { mergeTheme, navigation } from '../services/theme'
import { applyEnvironmentFavicon } from '../utils/environment'
import {
	findFacilityById,
	isActiveFacility,
	isSuperUser,
	pickActiveFacility
} from '../utils/staffFacility'

const drawerWidth = 237

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9',
		paddingTop: 65,
		'& .no-top-padding': {
			paddingTop: 0
		}
	},

	selectedFacility: {
		marginLeft: 10,
		fontSize: 16,
		color: '#FFFFFF',
		textTransform: 'uppercase',
		fontFamily: 'Nunito',
		fontWeight: 'bold'
	},

	arrow: {
		marginLeft: 10,
		fontSize: 20,
		color: 'rgba(255, 255, 255, 0.6)'
	},

	drawer: {
		[theme.breakpoints.up('md')]: {
			width: drawerWidth,
			flexShrink: 0
		},
		paper: {
			top: 'auto'
		}
	},

	appBar: {
		boxShadow: 'none',
		width: '100%',
		zIndex: 1201
	},

	toolBar: {
		backgroundColor: '#3B0275'
	},

	logo: {
		height: 30
	},

	menuButton: {
		marginRight: theme.spacing(2),
		[theme.breakpoints.up('md')]: {
			display: 'none'
		}
	},

	backToFacilities: {
		cursor: 'pointer',
		alignItems: 'flex-start',
		'& .arrow-icon': {
			marginTop: 7
		}
	},

	toolbar: theme.mixins.toolbar,

	navToolbar: {
		display: 'flex',
		alignItems: 'center',
		'& h5': {
			color: '#FFFFFF',
			fontWeight: 900
		}
	},

	drawerPaper: {
		width: drawerWidth,
		background: '#F3F3F3',
		fontSize: 16,
		position: 'auto',
		top: 'auto'
	},

	mainContent: {
		width: '100%',
		position: 'absolute',
		top: 60,
		paddingTop: 5
	},

	mainContentLower: {
		top: 110
	},

	content: {
		flexGrow: 1,
		[theme.breakpoints.up('md')]: {
			width: `calc(100% - ${drawerWidth}px)`,
			marginLeft: drawerWidth
		},
		'&.no-nav': {
			width: '100%',
			marginLeft: '0px'
		}
	},

	defaultNav: {
		'& a': {
			paddingTop: 12,
			paddingBottom: 12
		},
		'& a:nth-child(1)': {
			marginTop: 12
		}
	},

	toolbarItemsWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%'
	},

	toolbarItemsWrapperRight: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		width: '100%'
	},

	avatarButton: {
		height: 32,
		width: 32,
		padding: 0,
		marginRight: 10,
		'&:hover': {
			backgroundColor: 'transparent'
		}
	},

	bell: {
		color: '#FFFFFF',
		fontSize: 13
	},

	avatar: {
		width: 32,
		height: 32,
		backgroundColor: '#6B4AD6',
		color: '#FFFFFF',
		fontSize: 12,
		fontWeight: 'bold',
		fontFamily: 'Nunito'
	},

	notificationsButton: {
		backgroundColor: '#6B4AD6',
		borderRadius: 16,
		height: 32,
		width: 60,
		padding: 0,
		'&:hover': {
			backgroundColor: 'transparent'
		},
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-evenly'
	},

	notifications: {
		fontFamily: 'Nunito',
		color: '#FFFFFF',
		fontSize: 12,
		fontWeight: 'bold'
	},

	menu: {
		paddingLeft: 0,
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: '#3B0275',
			opacity: 0.6
		}
	},
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	},
	crumbs: {
		width: '100%',
		height: 50,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		padding: 10,
		paddingLeft: 20,
		border: '1px solid #D0CFD2',
		borderLeftWidth: 0,
		borderRightWidth: 0,
		borderTopWidth: 0,
		position: 'fixed',
		backgroundColor: '#FFF',
		zIndex: 999
		// top: 60,
		// left: 0,
		// right: 0
		// backgroundColor: "blue"
	},
	crumbInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	crumb: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: 'bold',
		textDecoration: 'none',
		color: '#3B0275',
		marginRight: 5,
		opacity: 0.6
	},
	selectedCrumb: {
		fontWeight: 800,
		fontSize: '16px',
		lineHeight: '22px',
		color: theme.palette.primary.main,
		opacity: 1,
		textTransform: 'uppercase'
	},
	flexAlignCenter: {
		display: 'flex',
		alignItems: 'center'
	}
}))

const PublicRoute = ({ component: Component, authed, ...rest }) => {
	return (
		<Route {...rest} render={(props) => (authed === false ? <Component {...props} /> : <Redirect to="/" />)} />
	)
}

function useQuery() {
	return new URLSearchParams(useLocation().search)
}

const App = (props) => {
	const classes = useStyles()
	const theme = useTheme()
	const dispatch = useDispatch()
	const query = useQuery()
	const matches = useMediaQuery(theme.breakpoints.up('md'))
	let location = useLocation()
	let params = useParams()
	let history = useHistory()

	const [authed, setAuthed] = useState(false)
	const [roles, setRoles] = useState([])
	const [mobileOpen, setMobileOpen] = useState(false)
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		let environment = process.env.REACT_APP_ENV
		let title = 'Skiptown Admin'
		if (!environment || environment === 'development') {
			title = 'LOCAL ADMIN'
		} else if (environment === 'staging') {
			title = 'STAGING ADMIN'
		}

		document.title = title
		applyEnvironmentFavicon()
	})

	const user = useSelector((state) => state.general.user.user)
	// const constantsLoading = useSelector((state) => state.general.constants.loading)

	const alert = useSelector((state) => state.general.main.alert)

	const selectedFacility = useSelector((state) => state.specific.facilities.selected)

	const markets = useSelector((state) => state.specific.markets.markets)
	const selectedMarket = useSelector((state) => state.specific.markets.selectedMarket)
	const marketsLoading = useSelector((state) => state.specific.markets.loading)
	const selectedPlaygroup = useSelector((state) => state.specific.facilities.selected_playgroup)

	const facilities = useSelector((state) => state.specific.facilities.facilities)
	const facilityLoading = useSelector((state) => state.specific.facilities.loading)

	const client = useSelector((state) => state.specific.households.selected)

	const teamMember = useSelector((state) => state.specific.team.selectedStaff)

	const visit = useSelector((state) => state.specific.visits.selected)

	useEffect(() => {
		let currentUser = user

		const unsubscribe = props.firebase.auth.onAuthStateChanged((user) => {
			if (user) {
				props.firebase.auth.currentUser
					.getIdToken()
					.then(async (token) => {
						if (token) {
							if (!authed) {
								setAuthed(true)
							}

							let decoded = jwt(token)
							if (!decoded.facility_id) {
								token = await props.firebase.auth.currentUser.getIdToken(true)
								decoded = jwt(token)
							}

							api.defaults.headers.common['Authorization'] = 'Bearer ' + token
							localStorage.setItem('accessToken', token)

							let roles = decoded && decoded.roles ? decoded.roles.map((role) => role) : []
							const facilityId = decoded?.facility_id || null

							if (
								!currentUser ||
								currentUser.facility_id !== facilityId ||
								JSON.stringify(currentUser.roles || []) !== JSON.stringify(roles)
							) {
								setRoles(roles)

								dispatch(
									setUser({
										roles: roles,
										email: decoded.email,
										displayName: user.displayName,
										uid: user.uid,
										facility_id: facilityId
									})
								)
							}
						}
					})
					.catch((e) => {
						console.log('err here', e)
						setAuthed(false)
					})
					.finally(() => {
						setLoading(false)
					})
			} else {
				setLoading(false)
				setAuthed(false)
			}
		})

		return () => unsubscribe()
		// Subscribe once. Without deps this re-subscribed on every render, and each new
		// subscription fetched a token again; a failed refresh flipped `authed` and remounted
		// every page, which put the Schedule page in a refetch loop (prod, Oct 30 2026).
	}, [])

	useEffect(() => {
		if (user) {
			if (!facilities && !facilityLoading) {
				dispatch(getFacilities())
			}

			if (!markets && !marketsLoading) {
				dispatch(getMarkets())
			}
		}
	}, [user, facilities])

	useEffect(() => {
		dispatch(getConstants())
	}, [])

	useEffect(() => {
		const selectFacility = (facility) => {
			if (!facility?._id) return
			dispatch(setFacility(facility))
			localStorage.setItem('facilityID', `${facility._id}`)
		}

		const roles = user ? user.roles : []
		const assignedFacilityId = user?.facility_id
		const canSwitchFacilities = isSuperUser(roles)

		if (facilities && facilities.length > 0) {
			const match = matchPath(location.pathname, {
				path: '/facilities/:facilityId/'
			})
			const urlFacilityId = match?.params?.facilityId || null
			const storedFacilityId = localStorage.getItem('facilityID')
			const urlFacility = findFacilityById(facilities, urlFacilityId)
			const storedFacility = findFacilityById(facilities, storedFacilityId)
			const assignedFacility = findFacilityById(facilities, assignedFacilityId)
			const lockedFacility = !canSwitchFacilities && isActiveFacility(assignedFacility) ? assignedFacility : null
			const preferredFacility =
				lockedFacility ||
				(isActiveFacility(urlFacility) ? urlFacility : null) ||
				(isActiveFacility(storedFacility) ? storedFacility : null) ||
				pickActiveFacility(facilities, storedFacility?.market_id || assignedFacility?.market_id || urlFacility?.market_id)

			if (lockedFacility && urlFacilityId && String(urlFacilityId) !== String(lockedFacility._id)) {
				const nextPath = location.pathname.replace(
					`/facilities/${urlFacilityId}`,
					`/facilities/${lockedFacility._id}`
				)
				history.replace(`${nextPath}${location.search || ''}`)
			}

			const selectedIsActive = isActiveFacility(selectedFacility)
			const selectedMatchesPreferred =
				selectedFacility?._id && preferredFacility?._id && String(selectedFacility._id) === String(preferredFacility._id)

			if (urlFacilityId && preferredFacility && !isActiveFacility(urlFacility)) {
				history.replace(
					`${location.pathname.replace(`/facilities/${urlFacilityId}`, `/facilities/${preferredFacility._id}`)}${location.search || ''}`
				)
			}

			if (preferredFacility && (!selectedIsActive || !selectedMatchesPreferred)) {
				selectFacility(preferredFacility)
			} else if (!urlFacilityId && preferredFacility?._id && location.pathname === '/') {
				if (roles.length === 1 && roles.includes('Groomer')) {
					history.push(`/facilities/${selectedFacility._id}/groomingHome`)
				} else {
					history.push(`/facilities/${selectedFacility._id}/schedule`)
				}
			}
		}
	}, [facilities, dispatch, location.pathname, selectedFacility, user])

	useEffect(() => {
		if (selectedFacility && selectedFacility._id) {
			const match = matchPath(location.pathname, {
				path: '/clients/:clientId'
			})

			let isClientId = match ? match.params.clientId !== 'create' : false

			if (
				(match && match.params.clientId && isClientId && !client) ||
				(client && match && isClientId && client._id !== match.params.clientId)
			) {
				dispatch(getHouseholdById(match.params.clientId))
			}
		}
	}, [selectedFacility, 'selectedFacility._id', location])

	useEffect(() => {
		if (client && client._id) {
			dispatch(getBalances(client._id))
			dispatch(getTransactions(client._id))
		}
	}, [client ? client._id : client])

	useEffect(() => {
		if (selectedFacility && selectedFacility._id) {
			const match = matchPath(location.pathname, {
				path: '/facilities/:facilityId/team/:staffId'
			})
			let isStaffId = match ? match.params.staffId !== 'create' : false

			if (
				(match && match.params.staffId && !teamMember && isStaffId) ||
				(teamMember && match && teamMember._id !== match.params.staffId)
			) {
				dispatch(getStaffById(match.params.staffId))
			}
		}
	}, [selectedFacility, 'selectedFacility._id', location])

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen)
	}

	const drawerWrapper = (children) => {
		let props = !matches
			? {
				variant: 'temporary',
				anchor: theme.direction === 'rtl' ? 'right' : 'left',
				open: mobileOpen,
				onClose: handleDrawerToggle,
				classes: {
					paper: classes.drawerPaper
				},
				ModalProps: {
					keepMounted: true
				}
			}
			: {
				classes: {
					paper: classes.drawerPaper
				},
				variant: 'permanent',
				open: true
			}

		return (
			<ThemeProvider theme={(theme) => createTheme(mergeTheme(theme, navigation))}>
				<Drawer {...props}>
					<List>{children}</List>
				</Drawer>
			</ThemeProvider>
		)
	}

	const getNavItems = () => {
		if (
			location.pathname.includes('unassigned') ||
			location.pathname.includes('appointment/create') ||
			location.pathname.includes('clients/create') ||
			location.pathname.includes('pets/add')
		) {
			return null
		}

		if (location.pathname.includes('globalAdmin'))
			return <AdminNavLinks location={location} selectedMarket={selectedMarket} />

		if (location.pathname.includes('playgroup/')) return null
		if (location.pathname.includes('monitor')) {
			return <MonitorNavLinks selectedFacility={selectedFacility} />
		}

		if (location.pathname.includes('clients/')) {
			return <ClientNavLinks selectedFacility={selectedFacility} client={client} roles={user?.roles || []} />
		}

		if (location.pathname.includes('settings')) {
			return <SettingsNavLinks selectedFacility={selectedFacility} client={client} />
		}

		if (location.pathname.includes('facilityMarketing')) {
			return <FacilityMarketingNavItems selectedFacility={selectedFacility} />
		}

		if (location.pathname.includes('facilitySetup')) {
			return <FacilitySetupNavItems selectedFacility={selectedFacility} />
		}

		if (location.pathname.includes('facilityBooking')) {
			return <FacilityBookingNav selectedFacility={selectedFacility} location={location} />
		}

		if (location.pathname.includes('grooming')) {
			return <GroomingNav selectedFacility={selectedFacility} location={location} />
		}

		if (location.pathname.includes('training/setup')) {
			return <FacilityTrainingSetupNav selectedFacility={selectedFacility} />
		}

		if (location.pathname.includes('training')) {
			return <TrainingNav selectedFacility={selectedFacility} location={location} />
		}

		return <NavItems selectedFacility={selectedFacility} roles={user?.roles || []} />
	}

	const hasNav = () => {
		let appointmentMatch = matchPath(location.pathname, {
			path: '/clients/:clientId/appointments/:visitId'
		})

		let petMatch = matchPath(location.pathname, {
			path: '/clients/:clientId/pets/:petId'
		})

		let staffMatch = matchPath(location.pathname, {
			path: '/facilities/:facilityId/team/:staffId'
		})

		if (
			location.pathname.includes('clients/create') ||
			location.pathname.includes('appointment/create') ||
			location.pathname.includes('pets/add') ||
			location.pathname.includes('monitor/dashboard') ||
			appointmentMatch ||
			petMatch ||
			staffMatch
		) {
			return false
		}
		return true
	}

	const hasCrumbs = () => {
		if (
			location.pathname.includes('globalAdmin') ||
			location.pathname.includes('monitor') ||
			location.pathname.includes('clients/') ||
			location.pathname.includes('team/') ||
			location.pathname.includes('facilityMarketing') ||
			location.pathname.includes('facilitySetup') ||
			location.pathname.includes('facilityBooking') ||
			location.pathname.includes('settings/') ||
			location.pathname.includes('grooming') ||
			location.pathname.includes('training')
		) {
			return true
		}
		return false
	}

	const getBreadCrumbs = () => {
		if (location.pathname.includes('globalAdmin')) return adminCrumbs
		if (location.pathname.includes('monitor')) {
			return monitorCrumbs
		}

		if (location.pathname.includes('clients/')) {
			return clientCrumbs
		}

		if (location.pathname.includes('facilityMarketing')) {
			return marketingCrumbs
		}

		if (
			location.pathname.includes('facilitySetup') ||
			location.pathname.includes('facilityBooking') ||
			location.pathname.includes('training/setup')
		) {
			return facilityCrumbs
		}

		if (location.pathname.includes('team/')) {
			return teamCrumbs
		}
		if (location.pathname.includes('settings/')) {
			return settingsCrumbs
		}

		if (location.pathname.includes('training')) {
			return trainingCrumbs
		}

		if (location.pathname.includes('grooming')) return groomingCrumbs

		return null
	}

	const getPlaygroup = () => {
		if (!selectedFacility || !selectedPlaygroup) return null
		let group = selectedFacility.playgroups.find((p) => p._id === selectedPlaygroup)
		return group ? group.name : ''
	}

	const getFacilitySetupCrumbLinks = () => {
		// todo ... think of a more elegant way to do this

		if (
			location.pathname.includes('facilitySetup') ||
			location.pathname.includes('facilityBooking') ||
			location.pathname.includes('training')
		) {
			return <FacilityBasicInfoNavLinks selectedFacility={selectedFacility} location={location} />
		}
	}

	const getMarketingCrumbLinks = () => {
		return <FacilityMarketingBreadCrumbs selectedFacility={selectedFacility} location={location} />
	}

	const getAdminCrumbLinks = () => {
		return <AdminCrumbs location={location} selectedMarket={selectedMarket} />
	}

	const getMonitorCrumbLinks = () => {
		// todo ... think of a more elegant way to do this
		const playGroup = getPlaygroup()

		if (location.pathname.includes('unassigned'))
			return <UnassignedNavLinks selectedFacility={selectedFacility} />
		if (location.pathname.includes('playgroups'))
			return <PlaygroupsNavLinks selectedFacility={selectedFacility} location={location} />

		if (location.pathname.includes('playgroup')) {
			return (
				<PlaygroupNavLinks
					selectedFacility={selectedFacility}
					playGroup={playGroup}
					selectedPlaygroup={selectedPlaygroup}
				/>
			)
		}
		if (location.pathname.includes('monitor')) {
			return <PathMonitorNavLinks selectedFacility={selectedFacility} location={location} />
		}
	}

	const getClientCrumbLinks = () => {
		let appointmentMatch = matchPath(location.pathname, {
			path: '/clients/:clientId/appointments/:visitId'
		})

		let petMatch = matchPath(location.pathname, {
			path: '/clients/:clientId/pets/:petId'
		})

		let staffMatch = matchPath(location.pathname, {
			path: '/facilities/:facilityId/team/:staffId'
		})

		let pet =
			petMatch && client && client.pets.length
				? client.pets.find((pet) => pet._id === petMatch.params.petId)
				: null

		// todo ... think of a more elegant way to do this
		if (petMatch && client && pet) {
			return (
				<PetMatchNavLinks
					selectedFacility={selectedFacility}
					location={location}
					client={client}
					pet={pet}
					roles={user?.roles || []}
				/>
			)
		}
		if (appointmentMatch && visit && client) {
			return (
				<AppointmentMatchNavLinks
					selectedFacility={selectedFacility}
					location={location}
					client={client}
					visit={visit}
					roles={user?.roles || []}
				/>
			)
		}
		if (location.pathname.includes('create')) {
			return <CreateClientNavLinks selectedFacility={selectedFacility} location={location} />
		}
		if (location.pathname.includes('appointments')) {
			return (
				<AppointmentsNavLinks
					selectedFacility={selectedFacility}
					location={location}
					client={client}
					visit={visit}
					roles={user?.roles || []}
				/>
			)
		}
		if (location.pathname.includes('contacts')) {
			return (
				<ContactsNavLinks
					selectedFacility={selectedFacility}
					location={location}
					client={client}
					roles={user?.roles || []}
				/>
			)
		}
		if (location.pathname.includes('household/data')) {
			return (
				<HouseholdDataNavLinks selectedFacility={selectedFacility} location={location} client={client} />
			)
		}
		if (location.pathname.includes('household')) {
			return (
				<HouseholdNavLinks
					selectedFacility={selectedFacility}
					location={location}
					client={client}
					roles={user?.roles || []}
				/>
			)
		}
		if (location.pathname.includes('pets/add')) {
			return (
				<AddPetsNavLinks
					selectedFacility={selectedFacility}
					location={location}
					client={client}
					roles={user?.roles || []}
				/>
			)
		}
		if (location.pathname.includes('pets')) {
			return (
				<PetsNavLinks
					selectedFacility={selectedFacility}
					location={location}
					client={client}
					roles={user?.roles || []}
				/>
			)
		}
		if (location.pathname.includes('membership')) {
			return (
				<MembershipNavLinks
					selectedFacility={selectedFacility}
					location={location}
					client={client}
					roles={user?.roles || []}
				/>
			)
		}
		if (location.pathname.includes('payments')) {
			return (
				<PaymentNavLinks
					selectedFacility={selectedFacility}
					location={location}
					client={client}
					roles={user?.roles || []}
				/>
			)
		}
		if (staffMatch) {
			return (
				<StaffNavLinks
					selectedfacility={selectedFacility}
					location={location}
					teamMember={teamMember}
					roles={user?.roles || []}
				/>
			)
		}
	}

	const getTeamCrumbLinks = () => {
		let staffMatch = matchPath(location.pathname, {
			path: '/facilities/:facilityId/team/:staffId'
		})

		if (staffMatch) {
			return (
				<StaffNavLinks selectedFacility={selectedFacility} location={location} teamMember={teamMember} />
			)
		}
	}

	const getSettingsCrumbLinks = () => {
		let settingsMatch = matchPath(location.pathname, {
			path: '/facilities/:facilityId/settings/'
		})

		if (settingsMatch) {
			return <SettingsBreadCrumbs selectedFacility={selectedFacility} location={location} />
		}
	}

	const getGroomingCrumbLinks = () => {
		return (
			<GroomingBreadCrumbs
				selectedFacility={selectedFacility}
				location={location}
				roles={user?.roles || []}
			/>
		)
	}

	const getTrainingCrumbLinks = () => {
		return <TrainingBreadCrumbs selectedFacility={selectedFacility} location={location} />
	}

	const hasTopPadding = () => location.pathname.includes('/login')

	const adminCrumbs = (
		<div id="crumbs" className={classes.crumbs}>
			{getAdminCrumbLinks()}
		</div>
	)

	const monitorCrumbs = (
		<div id="crumbs" className={classes.crumbs}>
			{getMonitorCrumbLinks()}
		</div>
	)
	const clientCrumbs = (
		<div id="crumbs" className={classes.crumbs}>
			{getClientCrumbLinks()}
		</div>
	)
	const teamCrumbs = (
		<div id="crumbs" className={classes.crumbs}>
			{getTeamCrumbLinks()}
		</div>
	)
	const settingsCrumbs = (
		<div id="crumbs" className={classes.crumbs}>
			{getSettingsCrumbLinks()}
		</div>
	)
	const groomingCrumbs = (
		<div id="crumbs" className={classes.crumbs}>
			{getGroomingCrumbLinks()}
		</div>
	)
	const facilityCrumbs = (
		<div id="crumbs" className={classes.crumbs}>
			{getFacilitySetupCrumbLinks()}
		</div>
	)
	const marketingCrumbs = (
		<div id="crumbs" className={classes.crumbs}>
			{getMarketingCrumbLinks()}
		</div>
	)
	const trainingCrumbs = (
		<div id="crumbs" className={classes.crumbs}>
			{getTrainingCrumbLinks()}
		</div>
	)

	const logOut = async () => {
		await props.firebase.auth.signOut()
		setAuthed(false)
		history.push('/login')
		dispatch({ type: 'RESET_APP' })
	}

	const app = (
		<div className={clsx([classes.root, { 'no-top-padding': hasTopPadding() }])}>
			<CssBaseline />
			<AppBar position="fixed" className={classes.appBar} color="primary">
				<Toolbar className={classes.toolBar}>
					{/*<IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>*/}
					<div className={classes.toolbarItemsWrapper}>
						<FacilityList />
					</div>
					<div className={classes.toolbarItemsWrapperRight}>
						<UserMenu user={user} logOut={logOut} />
						<IconButton className={classes.notificationsButton}>
							<i className={clsx('fa fa-bell', classes.bell)} />
							<span className={classes.notifications}>14</span>
						</IconButton>
					</div>
				</Toolbar>
			</AppBar>
			{getBreadCrumbs()}
			<div className={clsx([classes.mainContent, hasCrumbs() ? classes.mainContentLower : ''])}>
				{hasNav() ? (
					<nav className={classes.drawer}>{drawerWrapper(selectedFacility ? getNavItems() : null)}</nav>
				) : null}
				<main className={clsx([classes.content, !hasNav() ? 'no-nav' : ''])}>
					{privateRoutes(authed, roles)}
				</main>
				<Alert {...alert} />
			</div>
		</div>
	)

	// if (!roles || !roles.length) return <No/>

	return (
		<Switch>
			<PublicRoute authed={authed} path="/login" component={withFirebaseHOC(Login)} />
			{!loading ? app : <Loading />}
		</Switch>
	)
}

export default App